<template>
  <div class="faq-page pk-account-panel">
    <section class="faq-hero">
      <span>帮助中心</span>
      <h1>常见问题</h1>
      <p>常见问题集中在这里。本站使用手机号注册登录，打开箱子、箱子战斗、背包和账户相关规则以站内页面及消息通知为准。</p>
    </section>

    <section class="faq-layout">
      <aside class="faq-nav">
        <button
          v-for="group in faqGroups"
          :key="group.key"
          :class="{ active: activeKey === group.key }"
          @click="activeKey = group.key"
        >
          {{ group.title }}
        </button>
      </aside>

      <div class="faq-list">
        <article v-for="item in activeItems" :key="item.question" class="faq-card">
          <div class="faq-question" @click="toggle(item.question)">
            <strong>{{ item.question }}</strong>
            <span :class="{ open: openQuestion === item.question }"></span>
          </div>
          <p v-show="openQuestion === item.question">{{ item.answer }}</p>
        </article>
      </div>
    </section>

    <section class="contact-panel">
      <div>
        <span>客服支持</span>
        <strong>没有找到答案？</strong>
        <p>请联系站点客服处理充值、背包、活动奖励和账号问题。</p>
      </div>
      <button @click="copyText(contactNumber)">复制客服号</button>
      <em>{{ contactNumber }}</em>
    </section>

    <section class="feedback-panel">
      <div class="feedback-form">
        <span>问题反馈</span>
        <strong>提交问题反馈</strong>
        <p>登录后可以提交充值、背包、打开箱子、箱子战斗或账号问题。客服回复后会同步到站内通知。</p>
        <select v-model="feedbackForm.category">
          <option value="recharge">充值问题</option>
          <option value="inventory">背包/取回</option>
          <option value="case">打开箱子/箱子战斗</option>
          <option value="account">账号问题</option>
          <option value="cooperation">客服中心</option>
          <option value="other">其他问题</option>
        </select>
        <input v-model.trim="feedbackForm.title" maxlength="120" placeholder="问题标题">
        <textarea v-model.trim="feedbackForm.content" placeholder="请描述问题、订单号、箱子名称或出现时间"></textarea>
        <input v-model.trim="feedbackForm.contact" maxlength="120" placeholder="联系方式（选填）">
        <button @click="submitFeedback">提交反馈</button>
      </div>
      <div class="feedback-list">
        <div class="feedback-head">
          <div>
            <span>我的工单</span>
            <strong>我的反馈</strong>
          </div>
          <button @click="loadFeedback">刷新</button>
        </div>
        <article v-for="item in feedbackList" :key="item.id" class="feedback-card">
          <div>
            <b>{{ item.title }}</b>
            <em>{{ item.category_name }} / {{ item.status_name }}</em>
          </div>
          <p>{{ item.content }}</p>
          <p v-if="item.reply" class="reply">客服回复：{{ item.reply }}</p>
          <small>{{ item.update_time || item.create_time }}</small>
        </article>
        <div v-if="!feedbackList.length" class="feedback-empty">{{ feedbackMessage }}</div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeKey: "start",
      openQuestion: "如何注册和登录 pizzaking？",
      contactNumber: "313602570",
      feedbackForm: {
        category: "recharge",
        title: "",
        content: "",
        contact: "",
      },
      feedbackList: [],
      feedbackMessage: "登录后可查看自己的反馈记录。",
      faqGroups: [
        {
          key: "start",
          title: "开始使用",
          items: [
            {
              question: "如何注册和登录 pizzaking？",
              answer: "本站当前不使用 Steam 登录，注册和登录以手机号、密码或短信验证码为主。注册时可以填写邀请码，邀请码会绑定到合作伙伴计划。",
            },
            {
              question: "我需要绑定 Steam 吗？",
              answer: "目前不需要。本站使用手机号、密码或短信验证码完成账号登录，背包和取回状态可在个人中心查看。",
            },
            {
              question: "三种站内货币有什么区别？",
              answer: "披萨币用于充值后的打开箱子、箱子战斗和站内消费；小麦用于商城兑换；奶酪币和专属钥匙只用于后台已配置的对应箱子或活动。",
            },
          ],
        },
        {
          key: "cases",
          title: "打开箱子",
          items: [
            {
              question: "箱子和饰品数据来自哪里？",
              answer: "箱子、饰品、价格和最近掉落以站内展示的数据为准，不同箱子的可获得物品可在打开箱子详情页查看。",
            },
            {
              question: "如何查看箱子的可获得饰品？",
              answer: "进入对应箱子详情页后，可在打开箱子区域下方查看该箱子的饰品列表、最近掉落和当日最高价值掉落。",
            },
            {
              question: "打开箱子后获得的饰品在哪里？",
              answer: "打开箱子结果会进入背包页面。你可以在背包中查看物品状态、回收记录和取回记录。",
            },
          ],
        },
        {
          key: "battle",
          title: "对战",
          items: [
            {
              question: "如何查看对战房间？",
              answer: "在箱子战斗页面可以浏览进行中的房间、房间箱子、参与人数和状态；进入房间可查看对应对局信息。",
            },
            {
              question: "创建或加入对战会扣款吗？",
              answer: "参与前请确认房间的箱子、数量和价格。实际操作结果与余额变化以页面提示和账户账单记录为准。",
            },
            {
              question: "如何查看我的对战记录？",
              answer: "登录后可在对战页面切换到我的记录，或在个人中心查看与账户相关的记录信息。",
            },
          ],
        },
        {
          key: "wallet",
          title: "充值与账单",
          items: [
            {
              question: "充值页面是否可以直接使用？",
              answer: "充值页面会展示当前可用的充值入口和套餐。提交订单后，请以订单状态和账单记录为准。",
            },
            {
              question: "账单记录展示哪些内容？",
              answer: "账单页展示当前账号的充值、余额明细和饰品购买等记录，具体内容以账单页面为准。",
            },
            {
              question: "充值不到账怎么办？",
              answer: "请先在账单页核对订单状态和金额，再通过客服支持提交订单号与问题描述，客服回复会同步到站内通知。",
            },
          ],
        },
        {
          key: "withdraw",
          title: "背包与取回",
          items: [
            {
              question: "背包可以做什么？",
              answer: "当前背包展示已获得饰品，并支持按页面提示回收为披萨币余额。",
            },
            {
              question: "为什么取回按钮不可用？",
              answer: "取回进度会在背包和取回记录中展示。若订单需要处理或状态异常，请通过客服支持提交相关物品和订单信息。",
            },
            {
              question: "如何查询取回进度？",
              answer: "登录后进入个人中心的取回记录，可查看已提交物品的当前状态；状态更新也会同步到站内通知。",
            },
          ],
        },
      ],
    };
  },
  computed: {
    activeItems() {
      return this.faqGroups.find((group) => group.key === this.activeKey).items;
    },
  },
  mounted() {
    if (this.$route.query.category === "cooperation") {
      this.feedbackForm.category = "cooperation";
    }
    if (localStorage.getItem("userInfo")) {
      this.loadFeedback();
    }
  },
  methods: {
    toggle(question) {
      this.openQuestion = this.openQuestion === question ? "" : question;
    },
    copyText(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({ message: "复制成功", type: "success" });
    },
    submitFeedback() {
      if (!localStorage.getItem("userInfo")) {
        this.$store.commit("getLogin", true);
        return;
      }
      if (!this.feedbackForm.title) {
        this.$message.error("请填写问题标题");
        return;
      }
      if (!this.feedbackForm.content) {
        this.$message.error("请填写问题描述");
        return;
      }
      this.$axios
        .post("/index/System/submitFeedback", this.$qs.stringify(this.feedbackForm))
        .then((res) => {
          if (res.data.status !== 1) {
            this.$message.error(res.data.msg || "提交失败");
            return;
          }
          this.$message.success(res.data.msg || "反馈已提交");
          this.feedbackForm.title = "";
          this.feedbackForm.content = "";
          this.feedbackForm.contact = "";
          this.loadFeedback();
        });
    },
    loadFeedback() {
      if (!localStorage.getItem("userInfo")) {
        this.feedbackMessage = "登录后可查看自己的反馈记录。";
        this.feedbackList = [];
        return;
      }
      this.$axios
        .post("/index/System/myFeedback", this.$qs.stringify({ page: 1, pageSize: 8 }))
        .then((res) => {
          if (res.data.status !== 1) {
            this.feedbackMessage = res.data.msg || "暂时无法读取反馈记录。";
            this.feedbackList = [];
            return;
          }
          this.feedbackList = res.data.data.list || [];
          this.feedbackMessage = "暂无反馈记录。";
        });
    },
  },
};
</script>

<style lang="less" scoped>
.faq-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f4f6ff;
  background:
    radial-gradient(circle at 48% 0, rgba(255, 138, 31, 0.16), transparent 30%),
    radial-gradient(circle at 86% 28%, rgba(0, 217, 255, 0.08), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.faq-hero,
.faq-layout,
.contact-panel {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.faq-hero {
  min-height: 252px;
  padding: 48px 54px;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(39, 42, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.26);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.faq-hero::after {
  content: "";
  width: 720px;
  height: 260px;
  position: absolute;
  right: -130px;
  bottom: -150px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 138, 0, 0.38), transparent 66%);
}

.faq-hero span,
.contact-panel span {
  position: relative;
  z-index: 1;
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.faq-hero h1 {
  position: relative;
  z-index: 1;
  margin: 12px 0 14px;
  font-size: 70px;
  line-height: 0.95;
  font-weight: 1000;
}

.faq-hero p {
  position: relative;
  z-index: 1;
  max-width: 760px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
  font-weight: 800;
}

.faq-layout {
  margin-top: 24px;
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 18px;
  align-items: start;
}

.faq-nav {
  padding: 12px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(42, 45, 59, 0.92), rgba(28, 30, 41, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.055);
  box-shadow: 0 18px 54px rgba(0, 0, 0, 0.22);
}

.faq-nav button {
  width: 100%;
  height: 48px;
  margin-bottom: 8px;
  padding: 0 14px;
  color: #9ea7ba;
  text-align: left;
  background: #242735;
  border: 1px solid transparent;
  border-radius: 9px;
  font-size: 14px;
  font-weight: 1000;
}

.faq-nav button:last-child {
  margin-bottom: 0;
}

.faq-nav button.active {
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  box-shadow: 0 12px 30px rgba(255, 121, 0, 0.22);
}

.faq-list {
  display: grid;
  gap: 10px;
}

.faq-card {
  overflow: hidden;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.faq-question {
  min-height: 66px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  cursor: pointer;
}

.faq-question strong {
  color: #f7f9ff;
  font-size: 17px;
  font-weight: 1000;
}

.faq-question span {
  width: 34px;
  height: 34px;
  position: relative;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #2d3040;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.faq-question span::before,
.faq-question span::after {
  content: "";
  width: 14px;
  height: 2px;
  position: absolute;
  left: 9px;
  top: 15px;
  background: #ffb12c;
  border-radius: 2px;
}

.faq-question span::after {
  transform: rotate(90deg);
}

.faq-question span.open::after {
  transform: rotate(0);
}

.faq-card p {
  margin: 0;
  padding: 0 22px 24px;
  color: #9fa8bb;
  font-size: 15px;
  line-height: 1.9;
  font-weight: 800;
}

.contact-panel {
  margin-top: 24px;
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 18px;
  align-items: center;
  border-radius: 14px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.feedback-panel {
  max-width: 1280px;
  margin: 24px auto 0;
  display: grid;
  grid-template-columns: 430px 1fr;
  gap: 18px;
}

.feedback-form,
.feedback-list {
  padding: 24px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 18px 54px rgba(0, 0, 0, 0.22);
}

.feedback-form span,
.feedback-head span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.feedback-form strong,
.feedback-head strong {
  display: block;
  margin-top: 8px;
  color: #f7f9ff;
  font-size: 24px;
  font-weight: 1000;
}

.feedback-form p {
  margin: 8px 0 16px;
  color: #9fa8bb;
  font-size: 14px;
  line-height: 1.7;
  font-weight: 800;
}

.feedback-form select,
.feedback-form input,
.feedback-form textarea {
  width: 100%;
  min-height: 44px;
  margin-bottom: 10px;
  padding: 0 14px;
  color: #f7f9ff;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  outline: none;
  font-family: inherit;
  font-weight: 800;
}

.feedback-form textarea {
  min-height: 108px;
  padding-top: 12px;
  resize: vertical;
}

.feedback-form button,
.feedback-head button {
  height: 44px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
  box-shadow: 0 12px 30px rgba(255, 121, 0, 0.24);
}

.feedback-head {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: center;
  margin-bottom: 14px;
}

.feedback-card {
  padding: 14px;
  margin-bottom: 10px;
  border-radius: 10px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.feedback-card div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.feedback-card b {
  color: #f7f9ff;
  font-size: 15px;
  font-weight: 1000;
}

.feedback-card em {
  color: #ffd764;
  font-style: normal;
  font-size: 13px;
  font-weight: 900;
}

.feedback-card p {
  margin: 10px 0 0;
  color: #9fa8bb;
  line-height: 1.7;
  font-weight: 800;
}

.feedback-card .reply {
  color: #f7f9ff;
}

.feedback-card small,
.feedback-empty {
  display: block;
  margin-top: 10px;
  color: #697287;
  font-weight: 800;
}

.contact-panel strong {
  display: block;
  margin-top: 8px;
  color: #f7f9ff;
  font-size: 24px;
  font-weight: 1000;
}

.contact-panel p {
  margin: 8px 0 0;
  color: #9fa8bb;
  font-size: 14px;
  font-weight: 800;
}

.contact-panel button {
  height: 44px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
  box-shadow: 0 12px 30px rgba(255, 121, 0, 0.24);
}

.contact-panel em {
  color: #ffd764;
  font-size: 16px;
  font-style: normal;
  font-weight: 1000;
}

@media screen and (max-width: 980px) {
  .faq-page {
    padding: 20px 12px 64px;
  }

  .faq-hero {
    padding: 34px 24px;
  }

  .faq-hero h1 {
    font-size: 52px;
  }

  .faq-layout,
  .contact-panel,
  .feedback-panel {
    grid-template-columns: 1fr;
  }
}
</style>
